import { notificationStrings, API_DOMAIN } from '@constants/app-constants';
import { call, put, takeEvery } from 'redux-saga/effects';
import Actions from '../action';
import Axios from 'axios';
import { openNotificationWithIcon } from '@sharedComponent/notification-message/notification';

export function* feeServiceWorker() {
	try {
		let companyId = localStorage.companyId || '';
		const uri = `${API_DOMAIN}/FeeDetail/` + companyId;
		let res = yield call(Axios.get, uri);
		yield put(Actions.creators.getfeeSuccess(res));
	} catch (err) {
		openNotificationWithIcon(notificationStrings.error, 'Failed To Fetch Data.');
		yield put(Actions.creators.getfeeError());
	}
}

export function* getTosServiceWorker() {
	try {
		console.log('SAGA ::');
		let companyId = localStorage.companyId || '';
		const uri = `${API_DOMAIN}/Company/` + companyId;
		let res = yield call(Axios.get, uri);
		console.log('TOS RES ::', res);
		yield put(Actions.creators.getTOSDataSuccess(res));
	} catch (err) {
		openNotificationWithIcon(notificationStrings.error, 'Network Error.');
		yield put(Actions.creators.getTOSDataError());
	}
}

export default function* feeWatcher() {
	yield takeEvery(Actions.types.GET_TOS_DATA, getTosServiceWorker);
	yield takeEvery(Actions.types.GET_FEE_DATA_START, feeServiceWorker);
}
